const ArrowDown = () => (
  <>
    <path
      fill="currentColor"
      d="m11.5 17.078-5.438-5.439a.48.48 0 0 0-.708.006.52.52 0 0 0-.163.354.49.49 0 0 0 .163.353l6.08 6.081a.8.8 0 0 0 .268.184q.136.053.298.053a.8.8 0 0 0 .298-.053.8.8 0 0 0 .268-.184l6.08-6.08a.5.5 0 0 0 .15-.342.48.48 0 0 0-.15-.366.5.5 0 0 0-.357-.165.5.5 0 0 0-.356.165L12.5 17.078V5.498a.48.48 0 0 0-.143-.356.48.48 0 0 0-.357-.143.48.48 0 0 0-.357.143.48.48 0 0 0-.143.357z"
    />
  </>
)
export default ArrowDown
